module.exports = __webpack_public_path__ + "img/starEnd.a7f60dbf.png";